// The definition module alone: this file reaches server pages and light client code.
import { viewPath } from '@repo/table/table-configuration/definition'

const loads = { pathname: '/loads' }

/** A Saved View of Loads has its own path; filters changed on top of it go in the search. */
export const savedViewPath = (id: number | string) => viewPath(loads, id)

/** The Loads list, plain or as a Saved View. */
export const isLoadsListPath = (pathname: string) =>
  pathname === loads.pathname || pathname.startsWith(viewPath(loads, ''))
